/**
 * Miroir frontend de `packages/backend/src/types/ocrCg.ts`.
 * ⚠️  Doit rester synchronisé avec le backend.
 */

export type CgDocType =
  | 'carte_grise'
  | 'cerfa_cession'
  | 'cerfa_demande_immat'
  | 'mandat'
  | 'assurance'
  | 'controle_technique'
  | 'piece_identite'
  | 'piece_identite_verso'
  | 'piece_identite_hebergeur'
  | 'piece_identite_hebergeur_verso'
  | 'piece_identite_cotitulaire'
  | 'piece_identite_cotitulaire_verso'
  | 'permis_conduire'
  | 'permis_conduire_verso'
  | 'permis_conduire_cotitulaire'
  | 'permis_conduire_cotitulaire_verso'
  | 'kbis'
  | 'kbis_vendeur'
  | 'kbis_acheteur'
  | 'justif_domicile'
  | 'attestation_hebergement'
  | 'recepisse_da'
  | 'acte_deces'
  | 'justif_succession';

export const CG_DOC_TYPES: readonly CgDocType[] = [
  'carte_grise',
  'cerfa_cession',
  'cerfa_demande_immat',
  'mandat',
  'assurance',
  'controle_technique',
  'piece_identite',
  'piece_identite_verso',
  'piece_identite_hebergeur',
  'piece_identite_hebergeur_verso',
  'piece_identite_cotitulaire',
  'piece_identite_cotitulaire_verso',
  'permis_conduire',
  'permis_conduire_verso',
  'permis_conduire_cotitulaire',
  'permis_conduire_cotitulaire_verso',
  'kbis',
  'kbis_vendeur',
  'kbis_acheteur',
  'justif_domicile',
  'attestation_hebergement',
  'recepisse_da',
  'acte_deces',
  'justif_succession',
];

export const isCgDocType = (value: unknown): value is CgDocType =>
  typeof value === 'string' && (CG_DOC_TYPES as readonly string[]).includes(value);

export interface CgOcrField<T = unknown> {
  value: T | null;
  confidence: number;
  source: 'extracted' | 'inferred' | 'not_found';
  /** Chaîne exacte telle que lue avant normalisation (immat/vin uniquement). */
  rawText?: string;
  /** Lectures alternatives plausibles (immat/vin sur cerfa_cession en priorité). */
  alternates?: string[];
}

export interface CgOcrResponse {
  docTypeDetected: CgDocType | 'unknown';
  docTypeMatch: boolean;
  docTypeMatchConfidence: number;
  unreadable: boolean;
  warnings: string[];
  fields: Record<string, CgOcrField>;
}

export interface CgOcrApiResponse {
  success: boolean;
  data?: CgOcrResponse;
  model?: string;
  usage?: { prompt_tokens: number; completion_tokens: number; total_tokens: number };
  error?: string;
}
